import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as IgPost } from '../../images/ig-post.svg';

export const IgPostIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={IgPost} />
);

export default IgPostIcon;
